import { Color, type Material, type MeshStandardMaterial } from 'three';

/**
 * Wspólne parametry wyglądu postaci — ustawiane przez aktywną scenę (strefa, obóz).
 * Jeden obiekt współdzielony przez wszystkie materiały, więc zmiana działa od razu wszędzie.
 */
export const RIM = {
  color: { value: new Color('#ffd9a0') },
  strength: { value: 0.6 },
};

const patched = new WeakSet<Material>();

/**
 * Światło konturowe (rim light): jasna obwódka na krawędziach postaci, odcina ją od tła.
 * Klasyczny zabieg w stylizowanych grafikach fantasy. Klony materiałów trzeba patchować osobno.
 */
export function addRim(material: Material): void {
  const m = material as MeshStandardMaterial;
  if (!m.isMeshStandardMaterial || patched.has(m)) return;
  patched.add(m);
  m.onBeforeCompile = (shader) => {
    shader.uniforms.uRimColor = RIM.color;
    shader.uniforms.uRimStrength = RIM.strength;
    shader.fragmentShader = shader.fragmentShader
      .replace('#include <common>', '#include <common>\nuniform vec3 uRimColor;\nuniform float uRimStrength;')
      .replace(
        '#include <emissivemap_fragment>',
        `#include <emissivemap_fragment>
        float rimDot = 1.0 - saturate(dot(normal, normalize(vViewPosition)));
        totalEmissiveRadiance += uRimColor * pow(rimDot, 3.0) * uRimStrength;`,
      );
  };
  m.customProgramCacheKey = () => 'rim';
  m.needsUpdate = true;
}
